import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = ["disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'CircleButton',
  props: {
  classes: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["flex items-center justify-center rounded-full focus:outline-none", __props.classes]),
      disabled: __props.disabled
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 10, _hoisted_2)
  ]))
}
}

})